import { Close } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'next-i18next';
import { useUsername } from '../../../../hooks/useUsername';
import { useContext } from 'react';
import { MessageContext } from '.';

export const ReplyTo = () => {
  const { replyTo, setReplyTo } = useContext(MessageContext);

  const { t } = useTranslation();
  const { getConstructedName } = useUsername();

  if (!replyTo) {
    return null;
  }

  return (
    <div className="flex flex-row justify-between w-full p-2 mb-1 rounded-lg bg-slate-200">
      <div className="flex flex-col text-gray-500">
        <p className="">{t('chat:reply-to', { name: getConstructedName(replyTo?.user) })}</p>
        <p className="text-sm break-normal hyphens-auto">{replyTo.message}</p>
      </div>
      <div>
        <IconButton size="small" onClick={() => setReplyTo(undefined)}>
          <Close fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};
